import { Typography } from 'antd'
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { getActionCardData } from '../../../../api';
import CountUp from 'react-countup';
import '../dash5.css'

function ActionStatusChangeRequests() {

    useEffect(() => {
        setShouldAnimate(true);
        loadData()

    }, [])

    const [cardData, setCardData] = useState(null)
    const [shouldAnimate, setShouldAnimate] = useState(false);

    const loadData = async () => {
        let agency
        let userLevel = await window.localStorage.getItem('ntfc_level')
        if (userLevel == 6 || userLevel == 7) {
            agency = 0
        } else {
            agency = window.localStorage.getItem('ntfc_agency')
        }

        getActionCardData(agency).then((out) => {

            setCardData(out.data.out)

        });

    }
    return (
        <div
            onClick={(e) => {
                e.stopPropagation()
                window.location.href = "/requests"

            }}
            style={{
                background: "white",
                borderRadius: "10px 0px 10px 10px",
                position: "relative",
                zIndex: 0,
                overflow: "hidden",
                transition: "0.6s ease-in",
                display: "flex"

            }}
            className='count-title-card2 enlarged-button2'
        >
            <div style={{
                flex: 1,
                textAlign: "center"
            }}>

                <Typography
                    className="hover-typography user-request-action-typo"
                    style={{ whiteSpace: "nowrap" }}
                >
                    {shouldAnimate && <CountUp end={cardData && cardData.status_change ? cardData.status_change : 0} duration={2} />}


                </Typography>
            </div>
            <div style={{
                flex: 2,
                display: "flex",
                alignItems: 'center',
                paddingRight: 33,
                textAlign: 'right'
            }}>
                <Typography
                    className="hover-typography user-request-action-typo-name"
                >
                    Action Status Change Requests
                </Typography>
            </div>






        </div>
    )
}

export default ActionStatusChangeRequests